module.exports = __webpack_public_path__ + "assets/images/test/household-sample-slope-desktop.png?v=88eeff3e";